// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"styles_horizontal__8BdL2","vertical":"styles_vertical__AJ7aX"};